// import './wdyr';
import DateFnsUtils from '@date-io/date-fns';
import {
  createGenerateClassName,
  jssPreset,
  StylesProvider
} from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import api from 'api';
import { configure } from 'axios-hooks';
import { create } from 'jss';
import jssExtend from 'jss-plugin-extend';
import rtl from 'jss-rtl';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Provider from 'react-redux/es/components/Provider';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { localeMap } from '../date-fns';
import AppContext from './AppContext';
import { Auth } from './auth';
import routes from './fuse-configs/routesConfig';
import ProvThemeProvider from './fuse-configs/ThemeProvider';
import CacheService from './services/cacheService';
import store from './store';
import renderRoutes from './fuse-configs/renderRoutes';
import GlobalLayout from './fuse-layouts/GlobalLayout';
import { QueryConfigure } from './main/components/prefabs/QueryConfigure';
import { QueryProvider } from './main/components/prefabs/QueryProvider';

export const axios = api;
configure({ axios, cache: false });

const authProvider = {
  getPermissions() {
    return [];
  }
};

const jss = create({
  ...jssPreset(),
  plugins: [...jssPreset().plugins, jssExtend(), rtl()],
  insertionPoint: document.getElementById('jss-insertion-point')
});

const generateClassName = createGenerateClassName();

const App = () => {
  // const checkCgu = () => {
  //   const userFromLocalStorage = localStorage.getItem('user');
  //   const user = JSON.parse(userFromLocalStorage);
  //   const acceptCgu = user?.accept_cgu;
  //   // owner is in the local storage during interpretation, meaning we don't want to show the TOU when an admin is emulating an other user
  //   const ownerFromLocalStorage = localStorage?.getItem('owner');
  //   const ownerLS = JSON.parse(ownerFromLocalStorage);

  //   // Check if TOU has not been accepted and owner is not in the local storage
  //   if (!acceptCgu && !ownerLS) {
  //     // Redirect to the /terms page
  //     history.push('/terms');
  //   }
  // };

  // useEffect(() => {
  //   // Check TOU on component mount
  //   checkCgu();
  // }, []);

  const {
    i18n: { language }
  } = useTranslation();

  CacheService.setRelationsToUpdate([
    {
      url: '/faqs',
      relationsToUpdate: [
        {
          targetRelation: '/faqsThematic',
          targetProperty: 'faqs',
          foreignKey: 'faq_thematic_id'
        }
      ]
    },
    {
      url: '/faqsThematic',
      onCreated: (entityCreated, entities) => {
        return entities.map(entity => {
          if (entity.position >= entityCreated.position) {
            entity.position++;
          }

          return entity;
        });
      },
      onDeleted: (entityDeleted, entities) => {
        return entities.map(entity => {
          if (entity.position > entityDeleted.position) {
            entity.position--;
          }

          return entity;
        });
      }
    }
  ]);

  return (
    <>
      {process.env.REACT_APP_ENV === 'stg' && (
        <div
          style={{
            background: '#1F1F1F',
            color: '#FFF',
            padding: '10px 20px',
            textAlign: 'center'
          }}
        >
          Ce site est un site de test pour le développement, si vous pensez être
          au mauvais endroit,{' '}
          <a style={{ color: '#FFF' }} href="https://connect.provalliance.com">
            cliquez ici
          </a>
        </div>
      )}
      <AppContext.Provider
        value={{
          routes
        }}
      >
        <StylesProvider jss={jss} generateClassName={generateClassName}>
          <Provider store={store}>
            <QueryConfigure cache={false} axios={axios}>
              <QueryProvider authProvider={authProvider}>
                <MuiPickersUtilsProvider
                  utils={DateFnsUtils}
                  locale={localeMap[language]}
                >
                  <BrowserRouter>
                    <Auth>
                      <ProvThemeProvider>
                        <Routes>
                          <Route path="/" element={<GlobalLayout />}>
                            <Route
                              index
                              element={<Navigate to="/dashboard" />}
                            />
                            {renderRoutes(routes)}
                          </Route>
                        </Routes>
                      </ProvThemeProvider>
                    </Auth>
                  </BrowserRouter>
                </MuiPickersUtilsProvider>
              </QueryProvider>
            </QueryConfigure>
          </Provider>
        </StylesProvider>
      </AppContext.Provider>
    </>
  );
};

export default App;
